module.exports = __webpack_public_path__ + "static/media/thunder.67021dbc.png";